import type { Sticker } from './useOwnership';
import { cellVM } from '../theme/statusColors';
import { Check } from '../theme/icons';

/** Foil-Sticker = Opening- oder Museum-Reihe (alle aus Folie/Glanz). */
export function isFoil(kind: string): boolean {
  return kind === 'opening' || kind === 'museum';
}

type Props = {
  sticker: Sticker;
  onTap: () => void;
};

export function StickerCell({ sticker, onTap }: Props) {
  const { code, count, kind } = sticker;
  const vm = cellVM(count);
  const foil = isFoil(kind);

  const ariaStatus =
    count === 0 ? 'fehlt' : count === 1 ? 'habe' : `doppelt ×${count - 1}`;

  return (
    <button
      type="button"
      onClick={onTap}
      className="dk-cell relative aspect-square rounded-[10px] flex items-center justify-center select-none font-mono text-[11.5px] font-semibold p-0 overflow-hidden"
      style={{
        background: vm.bg,
        color: vm.fg,
        border: vm.border,
        // Touch-target sichern (Visual System: ≥44px). aspect-square + Grid-Spalten machen das real.
      }}
      aria-label={`${code}, Status ${ariaStatus}`}
    >
      <span className="relative z-10">{code}</span>

      {vm.showCheck && (
        <Check
          size={12}
          width={4.2}
          stroke="#ffffff"
          style={{ position: 'absolute', top: 4, right: 4, zIndex: 10 }}
        />
      )}

      {vm.badge && (
        <span
          className="absolute font-mono font-bold flex items-center justify-center"
          style={{
            top: -6,
            right: -6,
            minWidth: 19,
            height: 19,
            padding: '0 4px',
            background: 'var(--cell-badge-bg)',
            color: '#fff',
            fontSize: 9.5,
            borderRadius: 10,
            border: '2px solid var(--color-bg)',
            animation: 'dkpop .2s ease',
            zIndex: 10,
          }}
        >
          {vm.badge}
        </span>
      )}

      {foil && (
        <span
          className="dk-foil absolute inset-0 pointer-events-none"
          style={{ borderRadius: 8 }}
          aria-hidden="true"
        />
      )}
    </button>
  );
}
